import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="network-header">
      <div className="nav-wrapper">
        <Link to="/" className="network-logo">
          Perth Lawn Coring
        </Link>

        <nav className="network-nav desktop-nav">
          <Link
            to="/"
            className={`network-nav-link ${isActive('/') ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link
            to="/services"
            className={`network-nav-link ${isActive('/services') ? 'active' : ''}`}
          >
            Services
          </Link>
          <Link
            to="/service-areas"
            className={`network-nav-link ${isActive('/service-areas') ? 'active' : ''}`}
          >
            Service Areas
          </Link>
          <Link
            to="/reviews"
            className={`network-nav-link ${isActive('/reviews') ? 'active' : ''}`}
          >
            Reviews
          </Link>
          <Link
            to="/contact"
            className={`network-nav-link ${isActive('/contact') ? 'active' : ''}`}
          >
            Contact
          </Link>
          <a href="tel:0417910217" className="btn-primary header-btn">
            <Phone size={18} />
            0417 910 217
          </a>
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-nav">
          <Link
            to="/"
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/services"
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Services
          </Link>
          <Link
            to="/service-areas"
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Service Areas
          </Link>
          <Link
            to="/reviews"
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Reviews
          </Link>
          <Link
            to="/contact"
            className="mobile-nav-link"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact
          </Link>
          <a href="tel:0417910217" className="btn-primary mobile-call-btn">
            <Phone size={18} />
            Call Now
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;